import React from 'react';
import Hero from './components/media-report/Hero';
import Main from './components/media-report/Main';

const MediaReport = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default MediaReport;